import { app } from '../../../../app';
import { Controller } from './start-license-payment.controller';

app.component('licenseManagementStartLicensePayment', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./start-license-payment.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/start-payment/start-license-payment.component.js